import { useLocale } from 'next-intl';
import { getLocalizedValue } from '@/shared/lib/getLocalizedValue';
import { LocalizedString } from '@/shared/model/Language';

export const useGetLocalizedValue = () => {
    const locale = useLocale();

    return (localizedValue: LocalizedString) => {
        return getLocalizedValue(localizedValue, locale);
    };
};
